import {FC, useEffect, useState} from 'react'
import {ErrorMessage, Field, Formik, FormikValues} from 'formik'
import {StepperComponent} from '../../../_metronic/assets/ts/components'
import {
  createAccountSchemas,
  ICreateAccount,
  inits,
} from '../wizards/components/CreateAccountWizardHelper'
import {useAuth} from '../auth'
import axios from 'axios'
import {error} from 'console'

const plans = [
  {
    title: 'Plan Anual',
    subTitle: 'Recomendado',
    description: 'IVA incluido',
    price: '$3,299.00 MXN',
    preventa: '$2,490.00 MXN',
    stripeValue: 'PLAN-ANUAL',
    cupon: 'xPvwo6dr',
    default: true,
    custom: false,
    features: [
      {
        title: 'Listado de sentencias',
        supported: true,
      },
      {
        title: 'Búsqueda avanzada de sentencias',
        supported: true,
      },
      {
        title: 'Descarga de sentencias en PDF',
        supported: true,
      },
      {
        title: 'Análisis e identificación del argumento en sentencias',
        supported: true,
      },
      {
        title: 'Webinars / Videos',
        supported: true,
      },
      {
        title: 'Blog',
        supported: true,
      },
    ],
  },
  {
    title: 'Plan Mensual',
    subTitle: 'Recomendado',
    description: 'IVA incluido',
    price: '$299.00 MXN',
    preventa: '$299.00 MXN',
    stripeValue: 'PLAN-MENSUAL',
    cupon: 'CQwVkCjh',
    default: false,
    custom: false,
    features: [
      {
        title: 'Listado de sentencias',
        supported: true,
      },
      {
        title: 'Búsqueda avanzada de sentencias',
        supported: true,
      },
      {
        title: 'Descarga de sentencias en PDF',
        supported: true,
      },
      {
        title: 'Análisis e identificación del argumento en sentencias',
        supported: true,
      },
      {
        title: 'Webinars / Videos',
        supported: true,
      },
      {
        title: 'Blog',
        supported: true,
      },
    ],
  },
]

const ReactivateSubscription: FC = () => {
  const API_URL = process.env.REACT_APP_API_URL

  const [stepper, setStepper] = useState<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(createAccountSchemas[0])
  const [initValues] = useState<ICreateAccount>(inits)
  const [isSubmitButton, setSubmitButton] = useState(false)

  let [success, setSuccess] = useState(false)
  let [sessionId, setSessionId] = useState<string | null>('')
  let [plan, setPlan] = useState<string | null>('')
  let [subscription, setSubscription] = useState<string | null>('')

  const {currentUser} = useAuth()

  console.log(currentUser)

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)

    if (query.get('success')) {
      setSuccess(true)
      setSessionId(query.get('session_id'))
      setPlan(query.get('plan'))
      setSubscription(query.get('subscription'))

      const formData = {
        email: currentUser?.email,
        session_id: query.get('session_id'),
        plan: query.get('plan'),
        subscription: query.get('subscription'),
      }

      axios.post(API_URL + '/app/registrar-suscripcion', formData, {}).then(
        (res) => {
          console.log(res)
          window.location.href = '../'
        },
        (error) => {
          alert(error)
        }
      )
    }
  }, [sessionId, success, plan, subscription])

  const submitStep = (values: ICreateAccount, actions: FormikValues) => {
    if (!stepper) {
      return
    }

    if (stepper.currentStepIndex !== stepper.totatStepsNumber) {
      stepper.goNext()
    } else {
      stepper.goto(1)
      actions.resetForm()
    }

    setSubmitButton(stepper.currentStepIndex === stepper.totatStepsNumber)

    console.log(values)

    setCurrentSchema(createAccountSchemas[stepper.currentStepIndex - 1])
  }

  return (
    <>
      <Formik validationSchema={currentSchema} initialValues={initValues} onSubmit={submitStep}>
        <div className='w-100'>
          <div className='row mb-10'>
            <div className='col-lg-12'>
              <div className='pb-5 pb-lg-5'>
                <h1 className='d-flex align-items-center text-gray-900 select-plan-text'>
                  Selecciona el tipo de plan
                </h1>

                <div className='text-gray-500 fs-6'>
                  Si necesitas más información, visita la página
                  <a href='#' target='_blank' className='link-primary fw-bolder'>
                    {' '}
                    Planes
                  </a>
                  .
                </div>
              </div>
            </div>

            {/* <div className='col-lg-8'>
              <div className='pb-5 pb-lg-5'>
                <img
                  alt='Logo'
                  src='/media/products/promos/Img-promotion.png'
                  className='w-100'
                ></img>
              </div>
            </div> */}
          </div>

          <div className='fv-row'>
            <div className='row'>
              <div className='col-lg-6'>
                <span className='d-block fw-bold text-start'>
                  <p className=' text-center  fw-bold degradado-radial'>
                    <b>Recomendado Mejor Oferta</b>
                  </p>
                </span>
                <div className='card'>
                  <Field
                    type='radio'
                    className='btn-check'
                    name='accountType'
                    value='personal'
                    id='kt_create_account_form_account_type_personal'
                  />
                  <label
                    className='btn btn-outline btn-outline-dashed btn-outline-default p-5 d-flex align-items-center plan-card  box-shadow-green'
                    htmlFor='kt_create_account_form_account_type_personal'
                  >
                    {/*<KTIcon iconName='address-book' className='fs-3x me-5' />*/}

                    {/* <div className="diagonal-text">
                      <span>Preventa</span>
                    </div> */}

                    <span className='d-block fw-bold text-start'>
                      <div className='col-lg-12'>
                        <div className='tab-content  h-100  p-5'>
                          {plans.map((plan, index) => {
                            return (
                              <div key={`custom${index}`}>
                                {plan.title === 'Plan Anual' && !plan.custom && (
                                  <>
                                    <h1 className=' text-center text-green-o'>{plan.title}</h1>
                                    <span className='fw-bold fs-6 text-center'>
                                      {/* <p className="plan-price"><del className="text-gray-500">{plan.price}</del> <b className="text-gray-900">{plan.preventa}</b></p> */}
                                      <p className='plan-price'>
                                        <b className='text-gray-900'>{plan.price}</b>
                                      </p>
                                    </span>

                                    <span className='text-gray-500 fw-bold fs-6 text-center'>
                                      <p className='text-gray-900'>{plan.description}</p>
                                    </span>
                                    {/* <hr className='hr-image'></hr>
                                    <div
                                      className={`tab-pane fade` + (plan.default && 'show active')}
                                      id={`kt_upgrade_plan_${index}`}
                                      key={index}
                                    >
                                      <div className='pb-5'>
                                        <h4 className='text-gray-600'>Servicios incluidos</h4>
                                      </div>

                                      <div className='pt-1'>
                                        {plan.features!.map((feature, i) => {
                                          return (
                                            <div
                                              className={
                                                `d-flex align-items-center` +
                                                (i !== plan.features!.length - 1 && ' mb-5')
                                              }
                                              key={`${i}-${feature.title}`}
                                            >
                                              {feature.supported && (
                                                <>
                                                  <KTIcon
                                                    iconName="check-circle"
                                                    className="fs-1 text-green-c mr-10"
                                                  />
                                                  <span className='fs-5 text-gray-500 flex-grow-1'>
                                                    {feature.title}
                                                  </span>
                                                </>
                                              )}
                                              {!feature.supported && (
                                                <>
                                                  <KTIcon
                                                    iconName="cross-circle"
                                                    className="fs-1 text-organge"
                                                  />
                                                  <span className='fw-bold fs-5 text-gray-500 flex-grow-1 '>
                                                    {feature.title}
                                                  </span>
                                                </>
                                              )}
                                            </div>
                                          )
                                        })}
                                      </div>
                                    </div> */}

                                    <div className=' h-100  mt-10 form-plan'>
                                      {/* <p className="text-gray-900">Regístrate antes del <b className="text-green-c">31 de marzo 2025</b></p> */}
                                      <hr></hr>
                                      <form
                                        action={API_URL + '/stripe/checkout'}
                                        method='POST'
                                        className='text-center'
                                      >
                                        {/* Add a hidden field with the lookup_key of your Price */}
                                        <input type='hidden' name='plan' value={plan.title} />
                                        <input
                                          type='hidden'
                                          name='lookup_key'
                                          value={plan.stripeValue}
                                        />
                                        {/* <input type='hidden' name='cupon_id' value={plan.cupon} /> */}
                                        <input
                                          type='hidden'
                                          name='customer_email'
                                          value={currentUser?.email}
                                        />
                                        <button
                                          id='checkout-and-portal-button'
                                          className='btn btn-primary '
                                          type='submit'
                                        >
                                          Suscribirme
                                        </button>
                                      </form>
                                    </div>
                                  </>
                                )}
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </span>
                  </label>
                </div>
              </div>

              <div className='col-lg-6'>
                <span className='d-block fw-bold text-start'>
                  <p className=' text-center  fw-bold sin-degradado'>
                    <b>&nbsp;&nbsp;</b>
                  </p>
                </span>
                <div className='card'>
                  <Field
                    type='radio'
                    className='btn-check'
                    name='accountType'
                    value='personal'
                    id='kt_create_account_form_account_type_personal'
                  />
                  <label
                    className='btn btn-outline btn-outline-dashed btn-outline-default p-5 d-flex align-items-center plan-card  box-shadow-green'
                    htmlFor='kt_create_account_form_account_type_personal'
                  >
                    {/* <KTIcon iconName='address-book' className='fs-3x me-5' /> */}
                    {/* <div className="diagonal-text">
                        <span>Preventa</span>
                      </div> */}

                    <span className='d-block fw-bold text-start'>
                      <div className='col-lg-12'>
                        <div className='tab-content  h-100  p-5'>
                          {plans.map((plan, index) => {
                            return (
                              <div key={`custom${index}`}>
                                {plan.title === 'Plan Mensual' && !plan.custom && (
                                  <>
                                    <h1 className=' text-center text-green-o'>{plan.title}</h1>
                                    <span className='fw-bold fs-6 text-center'>
                                      {/* <p className="plan-price"><del className="text-gray-500">{plan.price}</del> <b className="text-gray-900">{plan.preventa}</b></p> */}
                                      <p className='plan-price'>
                                        <b className='text-gray-900'>{plan.price}</b>
                                      </p>
                                    </span>

                                    <span className='text-gray-500 fw-bold fs-6 text-center'>
                                      <p className='text-gray-900'>{plan.description}</p>
                                    </span>
                                    {/* <hr className='separator'></hr>
                                    <div
                                      className={`tab-pane fade` + (plan.default && 'show active')}
                                      id={`kt_upgrade_plan_${index}`}
                                      key={index}
                                    >
                                      <div className='pb-5'>
                                        <h4 className='text-gray-600'>Servicios incluidos</h4>
                                      </div>

                                      <div className='pt-1'>
                                        {plan.features!.map((feature, i) => {
                                          return (
                                            <div
                                              className={
                                                `d-flex align-items-center` +
                                                (i !== plan.features!.length - 1 && ' mb-5')
                                              }
                                              key={`${i}-${feature.title}`}
                                            >
                                              {feature.supported && (
                                                <>
                                                  <KTIcon
                                                    iconName='check-circle'
                                                    className='fs-1 text-green-c mr-10'
                                                  />
                                                  <span className='fs-5 text-gray-500 flex-grow-1'>
                                                    {feature.title}
                                                  </span>
                                                </>
                                              )}
                                              {!feature.supported && (
                                                <>
                                                  <KTIcon
                                                    iconName='cross-circle'
                                                    className='fs-1 text-organge'
                                                  />
                                                  <span className='fw-bold fs-5 text-gray-500 flex-grow-1 '>
                                                    {feature.title}
                                                  </span>
                                                </>
                                              )}
                                            </div>
                                          )
                                        })}
                                      </div>
                                    </div> */}

                                    <div className=' h-100  mt-10 form-plan'>
                                      {/* <p className="text-gray-900">Regístrate antes del <b className="text-green-c">31 de marzo 2025</b></p> */}
                                      <hr></hr>
                                      <form
                                        action={API_URL + '/stripe/checkout'}
                                        method='POST'
                                        className='text-center'
                                      >
                                        {/* Add a hidden field with the lookup_key of your Price */}
                                        <input type='hidden' name='plan' value={plan.title} />
                                        <input
                                          type='hidden'
                                          name='lookup_key'
                                          value={plan.stripeValue}
                                        />
                                        {/* <input type='hidden' name='cupon_id' value={plan.cupon} /> */}
                                        <input
                                          type='hidden'
                                          name='customer_email'
                                          value={currentUser?.email}
                                        />
                                        <button
                                          id='checkout-and-portal-button'
                                          className='btn btn-primary '
                                          type='submit'
                                        >
                                          Suscribirme
                                        </button>
                                      </form>
                                    </div>
                                  </>
                                )}
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </span>
                  </label>
                </div>
              </div>

              <div className='text-danger mt-2'>
                <ErrorMessage name='accountType' />
              </div>
            </div>
          </div>
        </div>
      </Formik>
    </>
  )
}

export {ReactivateSubscription}
